module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHJJREFUeNpifCuvwkAKYGIgEdBfA5OMNM+s6cxamsRqYLUwZ3Nz4VuxBJcedA0/16wDIkY+Plx6sPjha0k5XA/QhTQIJe6eTvaQoP+fPn2KiPn35CkBDUClcNV/r10nbMPvEyd/7dqDSzUQMA6DtAQQYAD0uC5L2mG/3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/right3.png
// module id = 623
// module chunks = 1 6